module.exports = __webpack_public_path__ + "img/academy_workshops-sm.422a4077.png";